module.exports = __webpack_public_path__ + "static/media/drowning.8f73a2be.jpg";